import request from './request.js';

/**
 * @param type
 * @param filters
 * @returns {Promise<any>}
 */
function generate(type, filters, accountID = null) {
    const options = {
        endpoint: `/reports/run/${ type }`,
        method: 'POST',
        body: {
            filters,
            accountID
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    generate
};